export default __webpack_public_path__ + "static/media/hands-2906458_1920.84df175e.jpg";